import React, { useState } from 'react';
import { useProcessPayout } from '../../hooks/usePaymentQueries';
import Button from '../common/Button';
import ConfirmDialog from '../common/ConfirmDialog';
import './AdminPaymentActions.css';

const AdminPaymentActions = ({ payment, onSuccess }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [notes, setNotes] = useState('');
  const processPayoutMutation = useProcessPayout();

  const canProcessPayout = payment?.employer_payment_status === 'employer_paid' &&
                          payment?.employee_payout_status !== 'employee_paid';

  const handleProcessPayout = () => {
    setShowConfirm(true);
  };

  const handleConfirmPayout = async () => {
    try {
      await processPayoutMutation.mutateAsync({
        paymentId: payment.id,
        notes: notes.trim() || undefined
      });
      setShowConfirm(false);
      setNotes('');
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      // Error is handled by the mutation hook
    }
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setNotes('');
  };

  if (!canProcessPayout) {
    return (
      <div className="admin-payment-actions admin-payment-actions--disabled">
        <p className="admin-payment-actions__message">
          {payment?.employer_payment_status !== 'employer_paid' 
            ? 'Employer payment is pending. Cannot process payout yet.'
            : 'Payout already processed.'}
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="admin-payment-actions">
        <Button
          variant="primary"
          size="medium"
          onClick={handleProcessPayout}
          disabled={processPayoutMutation.isPending}
          loading={processPayoutMutation.isPending}
          className="admin-payment-actions__button"
        >
          Process Payout
        </Button>
        <p className="admin-payment-actions__hint">
          Employee will receive payment via their connected Stripe account.
        </p>
      </div>

      <ConfirmDialog
        isOpen={showConfirm}
        onClose={handleCancel}
        onConfirm={handleConfirmPayout}
        title="Confirm Payout"
        message={`Are you sure you want to process the payout of ${new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP'
        }).format(payment?.employee_payout_amount || payment?.total_amount || payment?.amount || 0)} to the employee?`}
        confirmText="Process Payout"
        cancelText="Cancel"
        isLoading={processPayoutMutation.isPending}
      >
        <div className="admin-payment-actions__notes">
          <label htmlFor="payout-notes" className="admin-payment-actions__notes-label">
            Notes (optional)
          </label>
          <textarea
            id="payout-notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="admin-payment-actions__notes-input"
            placeholder="Add any notes about this payout..."
            rows={3}
          />
        </div>
      </ConfirmDialog>
    </>
  );
};

export default AdminPaymentActions;

